/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CashEventDto,
  ErrorMessage,
  RegisterCashEventDto,
} from '../models';
import {
    CashEventDtoFromJSON,
    CashEventDtoToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    RegisterCashEventDtoFromJSON,
    RegisterCashEventDtoToJSON,
} from '../models';

export interface RegisterCashEventsRequest {
    locationId: string;
    registerCashEventDto: Array<RegisterCashEventDto>;
}

/**
 * 
 */
export class CashEventControllerApi extends runtime.BaseAPI {

    /**
     */
    async registerCashEventsRaw(requestParameters: RegisterCashEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CashEventDto>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling registerCashEvents.');
        }

        if (requestParameters.registerCashEventDto === null || requestParameters.registerCashEventDto === undefined) {
            throw new runtime.RequiredError('registerCashEventDto','Required parameter requestParameters.registerCashEventDto was null or undefined when calling registerCashEvents.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/locations/{locationId}/register-cash-events`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.registerCashEventDto.map(RegisterCashEventDtoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CashEventDtoFromJSON(jsonValue));
    }

    /**
     */
    async registerCashEvents(requestParameters: RegisterCashEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CashEventDto> {
        const response = await this.registerCashEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
